export default function Credentials() {
  const partners = [{
    name: "Industrial Safety Board",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/safety_board.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/safety_board.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/safety_board.png-wvc-sizes"
  }, {
    name: "Aerospace Standards",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/aerospace_std.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/aerospace_std.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/aerospace_std.png-wvc-sizes"
  }, {
    name: "Pharmaceutical Compliance",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/pharma_comp.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/pharma_comp.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/pharma_comp.png-wvc-sizes"
  }, {
    name: "Fire Protection Association",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/fire_assoc.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/fire_assoc.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/fire_assoc.png-wvc-sizes"
  }, {
    name: "Risk Underwriting Group",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/risk_group.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/risk_group.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/risk_group.png-wvc-sizes"
  }, {
    name: "Engineering Council",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/eng_council.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/eng_council.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/eng_council.png-wvc-sizes"
  }];
  return <section data-section-id="11134" id="industry-credentials" className="bg-background text-foreground py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-6 md:px-12 lg:px-20">
        <div className="border-t border-border" />

        <div className="py-12 md:py-16">
          <div className="flex flex-col items-center text-center">
            <p className="font-default text-[13px] font-semibold uppercase tracking-[0.14em] text-foreground">
              Recognized by industry authorities
            </p>

            <div className="mt-4 h-px w-16 bg-border" aria-hidden="true" />

            <div className="mt-10 w-full">
              <ul className="grid grid-cols-2 gap-x-10 gap-y-10 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 lg:gap-x-20">
                {partners.map((partner, i) => <li data-index={i} key={partner.name} className="flex items-center justify-center">
                    <img src={partner.src} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.name} loading="lazy" decoding="async" className="max-h-7 w-auto object-contain opacity-60 grayscale transition-all duration-[240ms] ease-out hover:opacity-100 hover:grayscale-0" />
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-border" />
      </div>
    </section>;
}